import type { AlertErrorHandlerFactory } from '@/features/shell'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { type Job } from '@/features/jobs/Job'
import { type JobStore } from '@/features/jobs/JobStore'
import { task } from 'mobx-task'

/**
 * Closes a bookkeeping job once its cycles are done.
 */
export class BookkeepingCompleteJobDialogViewModel {
  readonly modal = new ModalViewModel()

  constructor(
    private readonly _jobStore: JobStore,
    private readonly _job: Job,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
  ) {}

  /**
   * Completes the job
   */
  submit = task.resolved(async () => {
    await this._jobStore
      .close(this._job)
      .catch(this._createAlertErrorHandler('Completing the job failed'))
    this.modal.close()
  })
}
